module.exports = __webpack_public_path__ + "static/ita-logo-97eb11337dc5fa6657ee33fc19141870.svg";